import HttpClient from "../services/HttpClient";
import {
  APP_URL,
  VACANT,
  ACTIVE_VACANT,
  ERROR_MESSAGE,
  VACANTSEARCH,
  VACANTSEARCHRH,
  CLOSEVACANT,
  APPLY_VACANT,
  VACANTPUBLICSEARCH,
} from "../constants";

import axios from "axios";
const axiosClient = axios.create();
axiosClient.CancelToken = axios.CancelToken;
axiosClient.isCancel = axios.isCancel;

export const saveVacant = (vacant, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL}${VACANT}`, vacant, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const getActiveVacants = (dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${ACTIVE_VACANT}`, headers)
      .then((response) => {
        if (response.data.result) {
          resolve(response);
        }
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getAllVacants = (dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${VACANT}`, headers)
      .then((response) => {
        if (response.data.result) {
          resolve(response);
        }
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getFilterVacancies = (filters, paginator, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL}${VACANTSEARCH}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getFilterVacanciesRH = (filters, paginator, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL}${VACANTSEARCHRH}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const applyToVacant = (body, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL}${APPLY_VACANT}`, body, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const closeAVacant = (vacantCloseData, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL}${CLOSEVACANT}`, vacantCloseData, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};



export const getFilterPublicVacancies = (filters, paginator, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    axiosClient.post(
      `${APP_URL}${VACANTPUBLICSEARCH}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};
